import style from './style.scss';
import loadErrorIcon from '../../assets/loadError.svg';
import { getAppParams } from '../app.util';
import intl from 'react-intl-universal';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const NewApp = () => {
  const codeMap = new Map([
    ['504', intl.get('请求超时，请刷新重试或报告问题')],
    ['404', intl.get('工作空间不存在或无访问权限')],
    ['500', intl.get('未知错误，请刷新重试或报告问题')],
  ]);
  const { code = '500' } = getAppParams();

  return (
    <div className={style.page}>
      <div className={style['err-con']}>
        <img src={loadErrorIcon} alt={intl.get('加载失败')} />
        <p>{codeMap.get(code)}</p>
      </div>
    </div>
  );
};

export default NewApp;
